<template>
  <div
    class="other-link"
    v-if="isPC || isPad"
    data-position="0"
    data-name="一同目睹"
    v-animate
  >
    <p class="fs68 ffm600">更多精彩｜一同目睹</p>
    <div class="two-card mt100">
      <div class="card">
        <div class="wd180">
          <p class="fs36 ffm600">即刻关注</p>
          <p class="fs16 grey86868B mt10 lh1_5 ffm400">
            微信扫码关注“OriginOS”获取系统最新资讯
          </p>
        </div>
        <PlusImage class="qr-code" :src="OTHER_LINK.QRcode" alt="二维码" />
        <div class="wd106">
          <p class="fs36 ffm600">微博</p>
          <a
            target="_blank"
            href="https://weibo.com/u/7506173780"
            data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',button_name:'前往OriginOS官方微博'}}"
          >
            <p class="fs16 grey86868B mt10 lh1_5 ffm400">
              前往 OriginOS官方微博
              <img class="arrow" :src="$IMAGE_HOST + rightArrow" alt="" />
            </p>
          </a>
        </div>
      </div>
      <div class="card">
        <div>
          <p class="fs36 ffm600">Funtouch OS</p>
          <p class="fs36 ffm600">探索未来，不止于此</p>
          <a
            target="_blank"
            href="https://www.vivo.com.cn/funtouchos"
            data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',button_name:'前往FuntouchOS10网站'}}"
          >
            <p class="fs16 grey86868B mt20 lh1 ffm400">
              <span>前往 Funtouch OS 10 网站</span>
              <img class="arrow" :src="$IMAGE_HOST + rightArrow" alt="" />
            </p>
          </a>
        </div>
        <div>
          <PlusImage
            class="funtouchOS-logo"
            :src="OTHER_LINK.FuntouchOS"
            alt="FuntouchOS"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="other-link"
    data-position="0"
    data-name="一同目睹"
    v-animate:threshold="0.01"
  >
    <PlusImage class="ol-bg" :src="OTHER_LINK.bg360" alt="" />
    <a
      target="_blank"
      href="https://weibo.com/u/7506173780"
      data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',button_name:'前往OriginOS官方微博'}}"
    >
      <div class="ol-weibo-link"></div>
    </a>
    <a
      target="_blank"
      href="https://www.vivo.com.cn/funtouchos"
      data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',button_name:'前往FuntouchOS10网站'}}"
    >
      <div class="ol-funtouchOS-link"></div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightArrow from "@/assets/right-arrow.svg";
import { OTHER_LINK } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
export default {
  name: "OtherLink",
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  data() {
    return {
      OTHER_LINK,
      rightArrow,
    };
  },
  mounted() {
    // 曝光埋点
    this.$nextTick(() => {
      initExposureTrack(".other-link")();
    });
  },
};
</script>

<style lang="scss" scoped>
.other-link {
  background: #f3f4f5;
  padding: 150 * $px1920vw + vw 240 * $px1920vw + vw 116 * $px1920vw + vw;
  .two-card {
    display: flex;
    justify-content: space-between;
    .card {
      margin-right: 20 * $px1920vw + vw;
      flex: 1;
      background: #fff;
      border-radius: 20 * $px1920vw + vw;
      width: 710 * $px1920vw + vw;
      height: 271.75 * $px1920vw + vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 60 * $px1920vw + vw;
      text-align: left;
      &:last-child {
        margin-right: 0;
      }
      .qr-code {
        width: 169 * $px1920vw + vw;
        height: 164 * $px1920vw + vw;
      }
      .wd180 {
        width: 188 * $px1920vw + vw;
      }
      .wd106 {
        width: 110 * $px1920vw + vw;
      }
      .lh1_5 {
        line-height: 1.5;
      }
      .lh1 {
        > * {
          float: left;
        }
      }
      .funtouchOS-logo {
        width: 190 * $px1920vw + vw;
        margin-top: 35 * $px1920vw + vw;
      }
      .arrow {
        margin-top: 5 * $px1920vw + vw;
      }
    }
  }
}
.isPad {
  .other-link {
    padding: 50 * $px676vw + vw 30 * $px676vw + vw 56 * $px676vw + vw;
    .fs68 {
      font-size: 30 * $px676vw + vw;
    }
    .two-card {
      .card {
        margin-right: 12 * $px676vw + vw;
        border-radius: 7.6 * $px676vw + vw;
        width: 288 * $px676vw + vw;
        height: 102 * $px676vw + vw;
        padding: 0 20 * $px676vw + vw;
        .fs36 {
          font-size: 11 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
        }
        .wd180 {
          width: 85 * $px676vw + vw;
        }
        .fs16 {
          font-size: 10 * $px676vw + vw;
        }
        .qr-code {
          width: 64 * $px676vw + vw;
          height: 62 * $px676vw + vw;
        }
        .wd106 {
          width: 70 * $px676vw + vw;
          .fs16 {
            font-size: 10 * $px676vw + vw;
          }
        }
        .lh1_5 {
          position: relative;
          .arrow {
            position: absolute;
            bottom: 4 * $px676vw + vw;
            right: 0;
            height: 10 * $px676vw + vw;
          }
        }
        .lh1 {
          .arrow {
            height: 10 * $px676vw + vw;
          }
        }
        .funtouchOS-logo {
          width: 78 * $px676vw + vw;
          margin-top: 15 * $px676vw + vw;
        }
      }
    }
  }
}

.isMobile {
  .other-link {
    padding: 0;
    margin: 0;
    position: relative;
    .ol-bg {
      width: 100%;
    }
    .ol-weibo-link {
      position: absolute;
      width: 94 * $px360vw + vw;
      height: 48 * $px360vw + vw;
      top: 536 * $px360vw + vw;
      left: 134.4 * $px360vw + vw;
      z-index: 2;
    }
    .ol-funtouchOS-link {
      position: absolute;
      width: 175 * $px360vw + vw;
      height: 30 * $px360vw + vw;
      bottom: 138 * $px360vw + vw;
      left: 96 * $px360vw + vw;
      z-index: 2;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad {
    .other-link {
      background: #222;
      .fs68 {
        color: #fff;
      }
    }
  }
}
</style>